module.exports = __webpack_public_path__ + "img/BlueSky.990a907a.png";